export const states = {
    Remitted: "Remitted",
    NotRemitted: "NotRemitted",
    Delivered: "Delivered",
};

export const translate = {
    Remitted: "Remitido",
    NotRemitted: "No remitido",
    Delivered: "Entregado",
};

export const select = Object.keys(states)
    .map(state => ({ value: state, label: translate[state] }));